// components/TerrainChart.js
import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';

const TerrainChart = ({ data }) => {
    const chartData = data.map((p, index) => ({
        name: `T${index + 1}`,
        elevation: p.elevation,
        coordinates: `${p.lng.toFixed(5)}, ${p.lat.toFixed(5)}`
    }));

    return (
        <div style={{ marginTop: "20px", padding: "1rem" }}>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData} margin={{ top: 20, right: 30, left: 50, bottom: 20 }}>
                    <CartesianGrid stroke="#444" />
                    <XAxis dataKey="name" stroke="#ccc" />
                    <YAxis
                        label={{
                            value: 'Nadmorska visina (m)',
                            angle: -90,
                            position: 'outsideLeft',
                            dy: -30,
                            dx:-30,
                            fill: "#ccc"
                        }}
                        stroke="#ccc"
                    />
                    <Tooltip
                        formatter={(value) => [`${value} m`, 'Visina']}
                        labelFormatter={(label) =>
                            chartData.find((item) => item.name === label)?.coordinates
                        }
                    />
                    <Line type="monotone" dataKey="elevation" stroke="#8884d8" dot />
                </LineChart>
            </ResponsiveContainer>

            {/* Legenda kao tabela */}
            <div style={{ marginTop: "30px" }}>
                <h3 style={{ color: "#fff" }}>Legenda</h3>
                <table style={{ width: "100%", borderCollapse: "collapse", color: "#fff" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#1e193b" }}>
                            <th style={thStyle}>Tačka</th>
                            <th style={thStyle}>Koordinate (lng, lat)</th>
                            <th style={thStyle}>Nadmorska visina (m)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {chartData.map((item, index) => (
                            <tr key={index} style={{ textAlign: "center", borderBottom: "1px solid #444" }}>
                                <td style={tdStyle}>{item.name}</td>
                                <td style={tdStyle}>{item.coordinates}</td>
                                <td style={tdStyle}>{item.elevation.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const thStyle = {
    padding: "8px",
    borderBottom: "1px solid #444"
};

const tdStyle = {
    padding: "8px"
};

export default TerrainChart;
